// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s0ne_","left":"styles_left__GKl5-","desktopActions":"styles_desktopActions__D6Iek","title":"styles_title__KGSpq"};